var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusDisconnectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 872.4 476.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.4,357.2c14.6-14.5,14.7-38.2,0.1-52.8L488.8,238l65.7-66.3c14.5-14.6,14.5-38.3-0.1-52.8s-38.3-14.5-52.8,0.1 L436.2,185l-65.4-65.9c-14.5-14.6-38.2-14.7-52.8-0.1c-14.6,14.5-14.7,38.2-0.1,52.8l65.7,66.3l-65.7,66.3 c-14.5,14.6-14.5,38.3,0.1,52.8c14.6,14.5,38.3,14.5,52.8-0.1l65.4-65.9l65.4,65.9C516.1,371.6,539.8,371.7,554.4,357.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.2,325.4c-12.6-26.5-19.6-56.1-19.6-87.3s7.1-60.9,19.6-87.3c23.8-50.1,67.5-88.9,120.8-106.3V0 c-77,20.4-139.2,77.1-167.1,150.7H87.3C39.1,150.7,0,189.8,0,238v0c0,48.2,39.1,87.3,87.3,87.3H206 c27.9,73.6,90.1,130.3,167.1,150.7v-44.4C319.7,414.3,276,375.5,252.2,325.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.1,150.7H666.5C638.6,77.1,576.4,20.4,499.4,0v44.4c53.4,17.4,97,56.2,120.8,106.3c12.6,26.5,19.6,56.1,19.6,87.3 s-7.1,60.9-19.6,87.3c-23.8,50.1-67.5,88.9-120.8,106.3v44.4c77-20.4,139.2-77.1,167.1-150.7h118.6c48.2,0,87.3-39.1,87.3-87.3v0 C872.4,189.8,833.3,150.7,785.1,150.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDisconnectedIcon);
export default __webpack_public_path__ + "static/media/status-disconnected-icon.6e842a8587fbc1995a31729d82edc587.svg";
export { ForwardRef as ReactComponent };